import classNames from 'classnames';
import { forwardRef, PropsWithChildren } from 'react';

export interface CardHeaderProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  padding?: boolean;
}

/**
 * Header component for cards
 */
const CardHeader = forwardRef<HTMLDivElement, PropsWithChildren<CardHeaderProps>>((props, ref) => {
  const { children, className, padding = true, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      ref={ref}
      className={classNames(
        'relative flex justify-between items-start',
        padding && 'p-4',
        className
      )}
    >
      {children}
    </div>
  );
});

CardHeader.displayName = 'CardHeader';

export { CardHeader };

export default CardHeader;
